import { render, staticRenderFns } from "./UjianFinish.vue?vue&type=template&id=a8678c46&scoped=true"
import script from "./UjianFinish.vue?vue&type=script&lang=js"
export * from "./UjianFinish.vue?vue&type=script&lang=js"
import style0 from "./UjianFinish.vue?vue&type=style&index=0&id=a8678c46&prod&scoped=true&lang=css"
import style1 from "./UjianFinish.vue?vue&type=style&index=1&id=a8678c46&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8678c46",
  null
  
)

export default component.exports